export default __webpack_public_path__ + "static/media/exam-overview-credit-icon.ca77bc77.svg";